'use client'

import { useRouter, useSearchParams } from 'next/navigation'
import { useEffect, useRef } from 'react'
import { Product } from '@/@types/productsType'
import Container from '../../components/CatalogContainer'
import { ProductCardSlider } from '@/components/template/ProductCardSlider'
import Pagination from '@/components/ui/Pagination'

interface ProductsListProps {
    initialProducts: Product[]
    page?: number
    limit?: number
    total?: number
}

const ProductsList = ({
    initialProducts,
    page,
    limit,
    total,
}: ProductsListProps) => {
    const router = useRouter()
    const searchParams = useSearchParams()
    const catalogRef = useRef<HTMLDivElement>(null)

    const handlePageChange = (newPage: number) => {
        const params = new URLSearchParams(searchParams.toString())
        params.set('page', newPage.toString())

        router.push(`?${params.toString()}`, { scroll: false })
    }

    useEffect(() => {
        if (!page) return

        const title = document.getElementById('catalog-title')
        const header = document.querySelector('header')

        if (!title) return

        const headerHeight = header?.offsetHeight ?? 0

        const y =
            title.getBoundingClientRect().top +
            window.scrollY -
            headerHeight -
            10

        window.scrollTo({
            top: y,
            behavior: 'smooth',
        })
    }, [page])

    return (
        <Container>
            <div ref={catalogRef}>
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 ">
                    {initialProducts.map((product: Product) => (
                        <ProductCardSlider key={product.id} {...product} />
                    ))}
                </div>

                {initialProducts.length > 0 && (
                    <div className="mt-5 mb-5 min-w-0 md:min-w-lg">
                        <Pagination
                            pageSize={limit}
                            currentPage={page}
                            onChange={handlePageChange}
                            total={total}
                        />
                    </div>
                )}
            </div>
        </Container>
    )
}
export default ProductsList
